import {NzConfig} from 'ng-zorro-antd/core/config';

export const NG_ZORRO_CONFIG: NzConfig = {
  message: { nzDuration: 5000 },

};
